import { Meeting } from 'src/app/types';

type BlockedTurn = {
  startHour: string;
  startTime: string;
  endHour: string;
  endTime: string;
  name?: string;
};

export const verifyZDate = (date: BlockedTurn): BlockedTurn => {
  if (date.name && date.startHour.toLocaleLowerCase().includes('z')) {
    if (date.startHour.split(':').length >= 3) {
      let splited = date.startHour.split(':');
      const currentDate = new Date();
      currentDate.setHours(+splited[0] - 4, +splited[1], 0);

      splited[0] = (+currentDate.getHours()).toString();

      splited[0] = fixHours(+splited[0]);
      splited[1] = fixHours(+splited[1]);

      date.startHour = splited.slice(0, 2).join(':');
    }

    if (date.endHour.split(':').length >= 3) {
      let splited = date.endHour.split(':');
      const currentDate = new Date();
      currentDate.setHours(+splited[0] - 4, +splited[1], 0);

      splited[0] = (+currentDate.getHours()).toString();

      splited[0] = fixHours(+splited[0]);
      splited[1] = fixHours(+splited[1]);

      date.endHour = splited.slice(0, 2).join(':');
    }
  }
  return date;
};

export const verifyZDate2 = (
  date: BlockedTurn | Meeting
): BlockedTurn | Meeting => {
  if (date.startHour.split(':').length >= 3) {
    let splited = date.startHour.split(':');
    const currentDate = new Date();
    currentDate.setHours(+splited[0] - 4, +splited[1], 0);

    splited[0] = (+currentDate.getHours()).toString();

    splited[0] = fixHours(+splited[0]);
    splited[1] = fixHours(+splited[1]);

    date.startHour = splited.slice(0, 2).join(':');
  }

  if (date.endHour.split(':').length >= 3) {
    let splited = date.endHour.split(':');
    const currentDate = new Date();
    currentDate.setHours(+splited[0] - 4, +splited[1], 0);

    splited[0] = (+currentDate.getHours()).toString();

    splited[0] = fixHours(+splited[0]);
    splited[1] = fixHours(+splited[1]);

    date.endHour = splited.slice(0, 2).join(':');
  }
  return date;
};

export const fixHours = (time) => {
  const fixTime = time < 10 ? `0${time}` : time;
  return fixTime;
};
